import { Link, Navigate, useParams } from "react-router-dom";
import './Gallery.css';
import arts from './Arts';
import artImages from './artImages.json';

function Detail() {
    const { artName } = useParams();
    const art = arts.find(a => a.fileName === artName);

    if (!art) return <Navigate to="/Gallery" replace />;

    return (
        <div className="detail_container">
            <div className="detail">
                <Link to='/Gallery'>
                    <img src={`/Art-full/${artImages[art.fileName].full}`} alt={art.comment}/>
                </Link>
                <div className="detailText">
                    <p>{art.comment}</p>
                    <div id="detail_tags">
                        <p className="filterName">TAGS</p>
                        <ul>
                            {art.tag.map(t => <li key={t}>{t}</li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Detail;
